<template>
  <div>
    <load-script src="//main.pubexchange.com/loader.min.js" :async="true" />
  </div>
</template>

<script>
  import LoadScript from '@Foundation/loadscript/loadscript';

  export default {
    name: 'article-pub-exchange',
    props: {
      pub: {
        type: String,
        required: false,
        default: 'makeupcom',
      },
      lazy: {
        type: Boolean,
        required: false,
        default: true,
      },
    },
    components: {
      LoadScript,
    },
    mounted() {
      window.PUBX = window.PUBX || {
        pub: this.pub,
        discover: false,
        lazy: this.lazy,
      };
    },
  };
</script>
